const get_configs = `/config-registry/prod-pipeline-configs`;
const config_data = id => `/config-registry/pipeline-configs/${id}/gopro-settings`;

export const configEndpoints = {
  get_configs,
  config_data
};
